import { AccountStatus } from '@/common/types'
import { ClientStatus } from '../types'

/**
 * Maps backend AccountStatus to frontend ClientStatus for grouping and display.
 * Returns null for ACTIVE status or undefined (legacy accounts without status).
 */
export function getClientStatus(accountStatus: AccountStatus | undefined): ClientStatus | null {
    if (accountStatus === undefined) {
        return null // Treat missing status as ACTIVE
    }

    switch (accountStatus) {
        case AccountStatus.KYC_NOT_STARTED:
        case AccountStatus.KYC_IN_PROGRESS:
            return ClientStatus.KYC_IN_PROGRESS
        case AccountStatus.KYC_FAILED:
            return ClientStatus.CONFIRMATION_FAILED
        case AccountStatus.AWAITING_CONFIRMATION:
            return ClientStatus.CLIENT_CONFIRMATION
        case AccountStatus.ACTIVE:
            return null
        case AccountStatus.KYC_SUBMITTED:
        case AccountStatus.ACCOUNT_SETUP_IN_PROGRESS:
            return ClientStatus.ACCOUNT_PROCESSING
        default:
            return ClientStatus.ACCOUNT_PROCESSING
    }
}
